<template>
  <form @submit.prevent="$emit('submit', form)">
    <div class="row g-3">
      <div class="col-12">
        <label class="form-label required">Nome no cartão</label>
        <input
          v-model="form.cardholder_name"
          type="text"
          class="form-control"
          autocomplete="cc-name"
          required
        />
      </div>
      <div class="col-12">
        <label class="form-label required">Número do cartão</label>
        <input
          v-model="form.card_number"
          type="text"
          class="form-control"
          autocomplete="cc-number"
          inputmode="numeric"
          maxlength="19"
          required
          @input="formatCardNumber"
        />
      </div>
      <div class="col-md-4">
        <label class="form-label required">Mês</label>
        <select v-model="form.expiration_month" class="form-select" required>
          <option value="">MM</option>
          <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label required">Ano</label>
        <select v-model="form.expiration_year" class="form-select" required>
          <option value="">AAAA</option>
          <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label required">CVV</label>
        <input
          v-model="form.security_code"
          type="password"
          class="form-control"
          autocomplete="cc-csc"
          maxlength="4"
          required
        />
      </div>
    </div>
    <div class="mt-4">
      <button type="submit" class="btn btn-primary" :disabled="loading">
        {{ submitLabel }}
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: 'PlatformSubscriptionCardForm',
  props: {
    loading: { type: Boolean, default: false },
    submitLabel: { type: String, default: 'Salvar cartão' },
  },
  emits: ['submit'],
  data() {
    const currentYear = new Date().getFullYear();
    return {
      form: {
        cardholder_name: '',
        card_number: '',
        expiration_month: '',
        expiration_year: String(currentYear),
        security_code: '',
      },
      months: Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0')),
      years: Array.from({ length: 12 }, (_, i) => String(currentYear + i)),
    };
  },
  methods: {
    formatCardNumber() {
      const digits = this.form.card_number.replace(/\D/g, '').slice(0, 16);
      this.form.card_number = digits.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
    },
    payload() {
      return {
        cardholder_name: this.form.cardholder_name,
        card_number: this.form.card_number.replace(/\s/g, ''),
        expiration_month: this.form.expiration_month,
        expiration_year: this.form.expiration_year,
        security_code: this.form.security_code,
      };
    },
  },
};
</script>

<style scoped>
.required::after {
  content: ' *';
  color: #f1416c;
}
</style>
